import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// Ready translated locale messages
const messages = {
  en: {
    page_title: '“Macao: Back to Common Roots” AR Cruise',
    scene1_title: 'The first theological college in the Far East',
    scene2_title: 'The first foreign (Portuguese) newspaper in China',
    scene3_title: 'The first Chinese newspaper with gaming advertisements in China',
    scene4_title: 'The first Western-style theatre in China',
    scene5_title: 'The first lighthouse in the Far East',
    scene6_title: 'The first Chinese-English dictionary in China',
    scene7_title: 'The first Western-style printing press in China',
    scene8_title: 'The first ophthalmic hospital in China',
    loading_wait: 'Loading， Please wait a monent...',
    please_aim: "Please Aim to target image",
    save_button_text: "Save Photo"
  },
  tw: {
    page_title: '「圖說澳門」AR海上遊',
    scene1_title: '遠東第一所神學院',
    scene2_title: '外國人在中國創辦的第一份報紙',
    scene3_title: '中國第一份帶博彩廣告的中文報紙',
    scene4_title: '中國第一間西式劇院',
    scene5_title: '遠東第一座燈塔',
    scene6_title: '中國第一本華英字典',
    scene7_title: '中國第一台西式印刷機',
    scene8_title: '中國第一間眼科醫院',
    loading_wait: '加載中，請稍後...',
    please_aim: "請對準識別圖",
    save_button_text: "保存相片"
  },
  cn: {
    page_title: '「图说澳门」AR海上游',
    scene1_title: '远东第一所神学院',
    scene2_title: '外国人在中国创办的第一份报纸',
    scene3_title: '中国第一份带博彩广告的中文报纸',
    scene4_title: '中国第一间西式剧院',
    scene5_title: '远东第一座灯塔',
    scene6_title: '中国第一本华英字典',
    scene7_title: '中国第一台西式印刷机',
    scene8_title: '中国第一间眼科医院',
    loading_wait: '加载中，请稍后...',
    please_aim: "请对准识别图",
    save_button_text: "保存相片"
  }
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'tw', // set locale
  messages, // set locale messages
})

export default i18n

// function loadLocaleMessages () {
//   const locales = require.context('./', true, /[A-Za-z0-9-_,\s]+\.json$/i)
//   const messages = {}
//   locales.keys().forEach(key => {
//     const matched = key.match(/([A-Za-z0-9-_]+)\./i)
//     if (matched && matched.length > 1) {
//       const locale = matched[1]
//       messages[locale] = locales(key)
//     }
//   })
//   return messages
// }

// export default new VueI18n({
//   locale: process.env.VUE_APP_I18N_LOCALE || 'en',
//   fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
//   messages: loadLocaleMessages()
// })
